import { DefType, GameExtension, PhaseEffect } from "~/business";
import { DefInstance, Entity, EntityRepository } from "~/utils";

export type IntrigueCard = DefInstance<"IntrigueCard">;

export type IntrigueCardProps = {
  name: string;
  phaseEffects: PhaseEffect[];
  instanceCount?: number;
  extension?: GameExtension;
};

class IntrigueCardRepository extends EntityRepository<
  IntrigueCardProps & Entity
> {
  fromName(name: string): IntrigueCard {
    const cardDef = intrigueCardsDefRepository.getById(name);
    return DefInstance.fromDef({
      defId: cardDef.id,
      defName: DefType.IntrigueCard,
    });
  }
  getDef(intrigueCard: IntrigueCard): IntrigueCardProps {
    return intrigueCard.getDef(intrigueCardsDefRepository);
  }
}

export const intrigueCardsDefRepository = new IntrigueCardRepository({
  entities: [],
});
